import { ComponentType, FC } from 'react';
import { useParams } from 'react-router-dom';

interface ChannelComponentWrapperProps {
  channelComponentMap: Record<string, ComponentType>;
  defaultComponent: ComponentType;
}

const ChannelComponentWrapper: FC<ChannelComponentWrapperProps> = ({
  channelComponentMap,
  defaultComponent: DefaultComponent,
}) => {
  const { channel } = useParams();
  const Component =
    (channel && channelComponentMap[channel.toLowerCase()]) || DefaultComponent;
  return <Component />;
};

export default ChannelComponentWrapper;
